import DOMPurify from "dompurify";

export function sanitize(html) {
  if (!html) return "";
  return DOMPurify.sanitize(html);
}

export function sanitizedHtml(html) {
  return { __html: sanitize(html) };
}
